import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, SCHOOLS } from '@/lib/api';
import { ArrowRight, BookOpen, Briefcase, GraduationCap, Award, Scale } from 'lucide-react';
const ICONS = { Scale, BookOpen, Briefcase, GraduationCap, Award };

export default function Schools() {
  const [programs, setPrograms] = useState([]);
  useEffect(() => { api.get('/programs').then(({ data }) => setPrograms(data)); }, []);

  return (
    <div data-testid="schools-page" className="bg-trjlight">
      <section className="bg-navy text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 hero-grain opacity-50" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <span className="trj-divider">Schools & Divisions</span>
          <h1 className="font-display font-semibold text-4xl lg:text-6xl mt-6 leading-tight">
            Five schools. One <span className="text-gold font-serif italic">academy</span>.
          </h1>
          <p className="mt-6 text-lg text-white/80 max-w-2xl">
            Each school within TRJ Academy is a complete pathway — from foundational training to advanced certification.
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 space-y-16">
        {SCHOOLS.map((s, i) => {
          const Icon = ICONS[s.icon];
          const schoolPrograms = programs.filter(p => p.school === s.name);
          return (
            <section key={s.slug} id={s.slug} className="scroll-mt-24" data-testid={`school-section-${s.slug}`}>
              <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
                <div className="bg-gradient-to-r from-navy to-navy-600 text-white p-8 lg:p-10 flex items-start gap-5">
                  <div className="h-14 w-14 rounded-lg bg-gold/20 text-gold flex items-center justify-center shrink-0">
                    <Icon className="h-7 w-7" />
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-widest text-gold font-semibold">School {String(i+1).padStart(2,'0')}</div>
                    <h2 className="font-display font-semibold text-2xl lg:text-3xl mt-1">{s.name}</h2>
                    <p className="text-white/80 mt-2 max-w-2xl">{s.tagline}</p>
                  </div>
                </div>
                <div className="p-8 lg:p-10">
                  {schoolPrograms.length === 0 ? (
                    <p className="text-slate-500">Programs from this school launch soon.</p>
                  ) : (
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                      {schoolPrograms.map(p => (
                        <Link key={p.program_id} to={`/programs/${p.slug}`}
                              data-testid={`school-program-${p.slug}`}
                              className="card-elevate group bg-white border border-slate-200 rounded-lg p-5 flex flex-col">
                          {p.is_coming_soon && (
                            <span className="text-[10px] tracking-widest uppercase font-semibold text-gold bg-gold/10 px-2 py-1 rounded self-start">Coming Soon</span>
                          )}
                          <h3 className="font-display font-semibold text-navy mt-2 leading-snug">{p.title}</h3>
                          <p className="text-sm text-slate-600 mt-2 flex-1">{p.short_description}</p>
                          <div className="mt-4 flex items-center justify-between border-t border-slate-100 pt-3">
                            {p.is_coming_soon ? (
                              <span className="text-sm text-slate-400">—</span>
                            ) : (
                              <span className="font-serif text-xl text-navy">${p.price_usd.toLocaleString()}</span>
                            )}
                            <span className="text-sm text-navy group-hover:text-gold inline-flex items-center">
                              View <ArrowRight className="ml-1 h-3.5 w-3.5" />
                            </span>
                          </div>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
}
